import Select from './Select';

export default Select;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-select/es/index.js
// module id = 58
// module chunks = 0